export class Scheduling {
    date: string;
    period: number;
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/models/payment/scheduling.ts